module.exports = __webpack_public_path__ + "img/ctrl-qft-stub-down-+i.d0e09517.svg";